import { h } from 'preact'
import formatDateInLocalTimezone from '../../utils/dateFormatting'

const DateCell = (accessor: string) => {
  return (props: any) => {
    const dateFromProps = props[accessor]
    if (!dateFromProps) {
      return null
    }

    const date = formatDateInLocalTimezone(dateFromProps)

    return <div className='overview__table-date'>{date}</div>
  }
}

export default DateCell
